import { useState } from 'react';

const OptimizedImage = ({ 
  src, 
  alt = "", 
  className = "",
  style = {},
}) => {
  const [loaded, setLoaded] = useState(false);

  if (!src) {
    return (
      <div 
        className={`bg-[#F7F7F7] flex items-center justify-center ${className}`}
        style={{ minHeight: '100px' }}
      >
        <span className="text-gray-400 text-xs">Sem imagem</span>
      </div>
    );
  }

  return (
    <img 
      src={src} 
      alt={alt} 
      className={className}
      loading="eager"
      onLoad={() => setLoaded(true)}
      style={{
        opacity: loaded ? 1 : 0,
        transition: 'opacity 0.3s ease-in',
        ...style,
      }}
    />
  );
};

export default OptimizedImage;
